import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { Register } from '@xanadu/core';
import { InputComponent } from '../input/input.component';
import { DictionaryValidator } from '../validator/dictionary-validator';

@Component({
    selector: 'app-dictionary',
    templateUrl: './dictionary.component.html',
    styleUrls: ['./dictionary.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
@Register('dictionary')
export class DictionaryComponent extends InputComponent {
    public metaKey: any;
    public metaValue: any;
    public dictionary: { key: string, value: string }[] = [];

    dictionaryArray: FormArray<any> = new FormArray<any>([], [DictionaryValidator('key')]);

    constructor(
    ) {
        super();

        const model = this.model();
        const meta = this.meta();
        const formGroup = this.formGroup();

        this.metaKey = { id: 'key', name: 'Key', pattern: meta.keyPattern, maxLength: meta.keyMaxLength };
        this.metaValue = { id: 'value', name: 'Value', pattern: meta.valuePattern, maxLength: meta.valueMaxLength };
        if (formGroup) {
        formGroup.addControl(meta.id, this.dictionaryArray);
        }
        if (model) {
            this.dictionary = model;
            this.dictionary.forEach(_ => {
                const group = new FormGroup({});
                this.dictionaryArray.push(group);
            });
        }
    }

    onAdd() {
        const formGroup = this.formGroup();
        const entry = { key: '', value: '' };
        this.dictionary.push(entry);
        const group = new FormGroup({});
        this.dictionaryArray.push(group);

        if (formGroup) {
            formGroup.markAsDirty();
            formGroup.updateValueAndValidity();
        }
    }

    onDelete(index: number) {
        this.dictionaryArray.removeAt(index);
        this.dictionary.splice(index, 1);
        const formGroup = this.formGroup();
        if (formGroup) {
            formGroup.markAsDirty();
        }
    }

    clearKey(index: number) {
        this.dictionary[index].key = '';
    }

    clearValue(index: number) {
        this.dictionary[index].value = '';
    }
}
